let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8pDdq")).then(() => parcelRequire('koa1e'));